/** @format */

const template = `
<div ng-if="$ctrl.paginationOver">
  <div class="row" ng-if="$ctrl.showPagination()">
    <div class="col-12">
      <sis-pagination
        scroll-into-view-on-page-change="{{$ctrl.scrollIntoViewElement}}"
        [total-items]="$ctrl.itemsTotalCount"
        [current-page]="$ctrl.currentPage"
        [items-per-page]="$ctrl.itemsPerPage"
        [max-size]="$ctrl.maxSize"
        (current-page-change)="$ctrl.onPageChangeOver($event)">
      </sis-pagination>
    </div>
  </div>
</div>
<div ng-if="$ctrl.loaded">
  <ng-transclude></ng-transclude>
</div>
<div ng-if="$ctrl.paginationUnder">
  <div class="row" ng-if="$ctrl.showPagination()">
    <div class="col-12">
      <sis-pagination
        scroll-into-view-on-page-change="{{$ctrl.scrollIntoViewElement}}"
        [total-items]="$ctrl.itemsTotalCount"
        [current-page]="$ctrl.currentPage"
        [items-per-page]="$ctrl.itemsPerPage"
        [max-size]="$ctrl.maxSize"
        (current-page-change)="$ctrl.onPageChangeUnder($event)">
      </sis-pagination>
    </div>
  </div>
</div>
`;
export default template;
